import axios from "axios";
import React, { useEffect, useState } from "react";

const SolveTicket = ({ onClose, ticket, handleToast, tech_id , tech_detail }) => {
  const [technicians, setTechnicians] = useState([]);
  const [techieId, setTechieId] = useState("");
  const [formData, setFormData] = useState({
    note: '',
    attachment: null
  })



  // Fetch technicians from API
  // useEffect(() => {
  //   const getTechies = async () => {
  //     try {
  //       const storedTechies = localStorage.getItem("techies");

  //       if (storedTechies) {
  //         setTechnicians(JSON.parse(storedTechies));
  //       } else {
  //         const response = await axios.get(
  //           "https://api.dectwinservices.com/api/get-techies"
  //         );
  //         setTechnicians(response.data);
  //         localStorage.setItem("techies", JSON.stringify(response.data));
  //       }
  //     } catch (e) {
  //       handleToast({
  //         toastMsg:
  //           "Something went wrong! Please Refresh page or check internet.",
  //         toastColor: "#FF0000",
  //       });
  //     }
  //   };
  //   getTechies();
  // }, [setTechnicians, handleToast]);

  useEffect(() => {
  const getTechies = async () => {
    try {
      const companyId = tech_detail.company_id;

      const response = await axios.get(
        `https://api.dectwinservices.com/api/get-techies-company/${companyId}`
      );

      setTechnicians(response.data);
    } catch (e) {
      handleToast({
        toastMsg:
          "Something went wrong! Please Refresh page or check internet.",
        toastColor: "#FF0000",
      });
    }
  };

  if (tech_detail?.company_id) {
    getTechies();
  }
}, [tech_detail?.company_id, handleToast]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.note == '') {
      handleToast({
        toastMsg: "Add Work Description Note",
        toastColor: "#4CAF50",
      });

      return;
    }

    try {
      const data = new FormData();
      data.append("note", formData.note);
      if (formData.attachment) {
        data.append("attachment", formData.attachment);
      }

      await axios.put(
        `https://api.dectwinservices.com/api/solve-ticket/${ticket.ticket_id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      handleToast({
        toastMsg: "Ticket Solved Successfully...",
        toastColor: "#4CAF50",
      });
      onClose();
    } catch (error) {
      handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };

  // Handle Ticket Transfer
  const handleTransfer = async (e) => {
    e.preventDefault();

    if (techieId === "") {
      handleToast({
        toastMsg: "Please Seect a Technician to transfer ticket...",
        toastColor: "#FF0000",
      });
      return;
    }
    if (parseInt(techieId) === tech_id) {
      handleToast({
        toastMsg: "You can't transfer Ticket to yourself...",
        toastColor: "#FF0000",
      });
      return;
    }

    try {
      await axios.put(
        `https://api.dectwinservices.com/api/transfer-ticket/${ticket.ticket_id}`,
        { to_id: techieId }
      );
      handleToast({
        toastMsg: "Ticket Transfered Successfully...",
        toastColor: "#4CAF50",
      });
      onClose();
    } catch (error) {
      handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };

    function removeSeconds(dateTime) {
  return dateTime.slice(0, 16);
}
  return (
    <div className="ticket-popup" style={{ overflow: "auto" }}>
      <div className="popup-content" style={{ display: 'block', padding: '1.8em' }}>
        {/* Left Side - Product Details */}
           <h3>Ticket Details: ID {ticket.ticket_inv}</h3>

{/* 
        <p>
          <strong>Title:</strong> {ticket.title}
        </p>
        <p>
          <strong>Description:</strong> {ticket.description}
        </p>
        <p>
          <strong>Category:</strong> {ticket.category}
        </p>
        <p>
          <strong>Sub Category:</strong> {ticket.sub_category}
        </p>
        <p>
          <strong>Priority:</strong> {ticket.priority}
        </p>
        <p>
          <strong>Impact Level:</strong> {ticket.impact_level}
        </p>
        <p>
          <strong>Raised On:</strong> {ticket.create_date}
        </p>

        <form>
          <div className="form-data w-100">
            <div class="input-icon">
              <input type="text" id="note" name="note" placeholder="Add Note" onChange={handleChange} style={{ height: '6em' }} />
            </div>
          </div>

          <div className="form-data w-100">
            <label htmlFor="attachment">Attachment (Upload Image/ Pdf)</label>
            <div class="input-icon">
              <input
                type="file"
                name="attachment"
                id="attachment"
                onChange={handleChange}
              // accept="image/*"
              />  </div>
          </div>

          <br />


          <div className="btn-group d-flex" style={{ justifyContent: "center" }}>
            <button
              className="add-btn"
              style={{ background: "#ec0e0e" }}
              onClick={onClose}
            >
              Go Back
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button type="submit" className="add-btn" onClick={handleSubmit}>
              Mark Solved
            </button>
          </div>

        </form> */}


        <div className="row">

  {/* Title */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Title</label>
    <div className="input-icon">
      <i className="bx bxs-layer"></i>
      <input className="form-control" value={ticket.title} readOnly />
    </div>
  </div>



  {/* Category */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Category</label>
    <div className="input-icon">
      <i className="bx bx-category"></i>
      <input className="form-control" value={ticket.category} readOnly />
    </div>
  </div>

  {/* Sub Category */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Sub Category</label>
    <div className="input-icon">
      <i className="bx bx-list-ul"></i>
      <input
        className="form-control"
        value={ticket.sub_category || "NA"}
        readOnly
      />
    </div>
  </div>

  {/* Priority */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Priority</label>
    <div className="input-icon">
      <i className="bx bx-error-circle"></i>
      <input className="form-control" value={`Priority ${ticket.urgency}`} readOnly />
    </div>
  </div>

  {/* Impact Level */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Impact Level</label>
    <div className="input-icon">
      <i className="bx bx-bolt-circle"></i>
      <input className="form-control" value={ticket.impact_level} readOnly />
    </div>
  </div>

  {/* Raised On */}

   <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Raised By</label>
    <div className="input-icon">
      <i className="bx bx-calendar"></i>
      <input className="form-control" value={ticket.staff_name} readOnly />
    </div>
  </div>

  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Raised On</label>
    <div className="input-icon">
      <i className="bx bx-calendar"></i>
      <input className="form-control" value={removeSeconds(ticket.create_date)} readOnly />
    </div>
  </div>

   <div className="form-data col-lg-4 col-md-6 col-12 ">
    <label>Raised Attachment</label>
    <div className="input-icon">
      <i className="bx bx-link"></i>


      {ticket.attachments ? (
  <a
    href={`https://api.dectwinservices.com/uploads/${ticket.attachments}`}
    target="_blank"
    rel="noopener noreferrer"
          style={{ color: "#007bff", textDecoration: "underline" ,height:'45px',paddingTop:'8px'  }}
  >
    {ticket.attachments.toLowerCase().endsWith(".pdf") ? (
      <i className="fa-solid fa-file-pdf" style={{ fontSize: "2em" }} />
    ) : (
      <i className="fa-solid fa-image" style={{ fontSize: "2em" }} />
    )}
  </a>
) : (
        <span style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
)}
    </div>
  </div>

  <div></div>
    {/* Description */}
  <div className="form-data col-12">
    <label>Description</label>
    <div className="input-icon">
      <i className="bx bx-detail mb-4"></i>
      <textarea
        className="form-control"
        value={ticket.description}
        readOnly
      />
    </div>
  </div>
 
  {/* Note Input */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Engineer Remark</label>
    <div className="input-icon">
      <i className="bx bx-note"></i>
      <input
        type="text"
        id="note"
        name="note"
        placeholder="Add Note"
        onChange={handleChange}
        style={{ height: "50px" }}
        required
      />
    </div>
  </div>

  {/* Attachment Upload */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label>Attachment (Upload Image / PDF)</label>
    <div className="input-icon">
      <i className="bx bx-upload"></i>
      <input
        type="file"
        name="attachment"
        id="attachment"
        onChange={handleChange}
      />
    </div>
  </div>



</div>

<div className="row ">
  <div className="d-flex justify-content-center gap-3 mt-3 w-100 mb-3">
    <button
      className="add-btn"
      style={{ background: "#ec0e0e" }}
      onClick={onClose}
      type="button"
    >
      Go Back
    </button>

    <button
      type="submit"
      className="add-btn"
      onClick={handleSubmit}
    >
      Mark Solved
    </button>
  </div>
  </div>

        {/* <br /> */}
        {/* <p style={{ textAlign: "center" }}>OR</p> */}
        <h2>
          Transfer Ticket
        </h2>
        <div className="form-data col-md-4 col-12">
          <div className="input-icon">
            <i className="bx bxs-user"></i>
            <select
              name="technician_id"
              id="technician_id"
              value={techieId}
              onChange={(e) => setTechieId(e.target.value)}
            // required
            >
              <option value="">Select Technician</option>
              {technicians.map((tech) => (
                <option key={tech.id} value={tech.id}>
                  {tech.name}
                </option>
              ))}
            </select>
          </div>
       
        <div className="form-data col-md-6 mt-2 col-12">    <button
              className="button-85"
              onClick={handleTransfer}
            >
              Transfer Now
            </button></div>  
        </div>
      </div>
    </div>
  );
};

export default SolveTicket;
